import { useEffect, useRef } from 'react';

const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function useModalA11y(isOpen, onClose) {
    const dialogRef = useRef(null);
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!isOpen) return undefined;

        const dialog = dialogRef.current;
        const previouslyFocused = document.activeElement;

        const focusables = () =>
            Array.from(dialog?.querySelectorAll(FOCUSABLE) || []).filter(
                (el) => !el.disabled && el.offsetParent !== null,
            );

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onCloseRef.current();
                return;
            }
            if (e.key !== 'Tab') return;

            const items = focusables();
            if (!items.length) return;

            const first = items[0];
            const last = items[items.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        const items = focusables();
        if (items[0]) items[0].focus();

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            if (previouslyFocused?.focus) previouslyFocused.focus();
        };
    }, [isOpen]);

    return dialogRef;
}
